import React, { Component } from 'react';
import { Typography, IconButton, Tooltip, Grid } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ContentCopyIcon from '@material-ui/icons/FileCopy';
import SectionCard from '../section-card';

/**
 * Card reusável "Dados do contrato" — renderizado em admin-trial-detail e admin-subscription-detail
 * como primeiro bloco da aba "Outras Informações".
 *
 * Props:
 *  - detail: objeto do detalhe (lowercase do backend: name, responsiblename, responsiblemail, responsiblephone, accesskey, workspace)
 *  - onCopied: callback opcional (msg) para mostrar snackbar de sucesso
 */
class HirerCredentialsCard extends Component {
    constructor(props) {
        super(props);
        this.state = { revealKey: false };
    }

    handleToggleReveal = () => this.setState(s => ({ revealKey: !s.revealKey }));

    handleCopy = async () => {
        try {
            const key = this.props.detail?.accesskey || '';
            if (!key) return;
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(key);
            } else {
                // Fallback
                const ta = document.createElement('textarea');
                ta.value = key;
                document.body.appendChild(ta);
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
            }
            if (this.props.onCopied) this.props.onCopied('Access Key copiada para a área de transferência');
        } catch (e) {
            if (this.props.onCopied) this.props.onCopied('Falha ao copiar');
        }
    }

    mask = (key) => {
        if (!key) return '—';
        // Mostra 4 primeiros + 4 últimos caracteres, resto mascarado
        if (key.length <= 10) return '•'.repeat(key.length);
        return `${key.substring(0, 4)}${'•'.repeat(Math.max(8, key.length - 8))}${key.substring(key.length - 4)}`;
    }

    render() {
        const detail = this.props.detail || {};
        const { revealKey } = this.state;
        const key = detail.accesskey || '';
        const displayed = revealKey ? (key || '—') : this.mask(key);

        return (
            <SectionCard context="info" title="Dados do contrato" actions={this.props.actions}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Nome do contratante</Typography>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>{detail.name || '—'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Workspace</Typography>
                        <Typography variant="body1" style={{ fontFamily: 'monospace', fontWeight: 500 }}>{detail.workspace || '—'}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Nome do responsável</Typography>
                        <Typography variant="body1">{detail.responsiblename || '—'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Email do responsável</Typography>
                        <Typography variant="body1">{detail.responsiblemail || detail.email || '—'}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Telefone do responsável</Typography>
                        <Typography variant="body1">{detail.responsiblephone || '—'}</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 4 }}>Access Key</Typography>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '8px 12px',
                            backgroundColor: '#fafafa',
                            border: '1px solid #e0e0e0',
                            borderRadius: 6,
                            maxWidth: 600,
                        }}>
                            <code style={{
                                flex: 1,
                                fontFamily: 'monospace',
                                fontSize: 14,
                                color: revealKey ? '#1976d2' : '#616161',
                                letterSpacing: revealKey ? 'normal' : 2,
                                wordBreak: 'break-all',
                            }}>
                                {displayed}
                            </code>
                            <Tooltip title={revealKey ? 'Ocultar' : 'Mostrar'}>
                                <IconButton size="small" onClick={this.handleToggleReveal} style={{ color: '#616161' }}>
                                    {revealKey ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Copiar">
                                <span>
                                    <IconButton size="small" onClick={this.handleCopy} disabled={!key} style={{ color: '#1976d2' }}>
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </div>
                    </Grid>
                </Grid>
            </SectionCard>
        );
    }
}

export default HirerCredentialsCard;
